export default "    <app-card-table title=\"Historial\" [columns]=\"columns\"></app-card-table>";